// Confetti cheer fired from both bottom corners (no external dependency).
// Returns a promise that resolves when the animation has finished and the canvas is removed.

const COLORS = ["#ff4d6d", "#ffd23f", "#3bceac", "#4cc9f0", "#b388ff", "#ff9f1c", "#ffffff"];

function makeParticle(x, y, dir, width, height) {
  // shoot up and towards the centre of the screen
  const angle = (Math.PI / 180) * (50 + Math.random() * 30); // 50-80deg from the floor
  const speed = (Math.min(width, height) / 38) * (0.7 + Math.random() * 0.9);
  return {
    x,
    y,
    vx: Math.cos(angle) * speed * dir,
    vy: -Math.sin(angle) * speed * 1.7,
    size: 6 + Math.random() * 7,
    color: COLORS[Math.floor(Math.random() * COLORS.length)],
    rot: Math.random() * Math.PI * 2,
    vr: (Math.random() - 0.5) * 0.4,
    tilt: Math.random() * Math.PI * 2,
    round: Math.random() < 0.25,
    life: 0,
  };
}

export function fireCornerConfetti({ duration = 2800, burstsEvery = 350, perBurst = 40 } = {}) {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    canvas.style.cssText = "position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:99999;";
    const dpr = window.devicePixelRatio || 1;
    const width = window.innerWidth;
    const height = window.innerHeight;
    canvas.width = width * dpr;
    canvas.height = height * dpr;
    document.body.appendChild(canvas);
    const ctx = canvas.getContext("2d");
    ctx.scale(dpr, dpr);

    const particles = [];
    const burst = () => {
      for (let i = 0; i < perBurst; i++) {
        particles.push(makeParticle(0, height, 1, width, height)); // bottom-left
        particles.push(makeParticle(width, height, -1, width, height)); // bottom-right
      }
    };

    const start = performance.now();
    let lastBurst = -Infinity;

    const frame = (now) => {
      const elapsed = now - start;
      if (elapsed < duration && now - lastBurst >= burstsEvery) {
        burst();
        lastBurst = now;
      }

      ctx.clearRect(0, 0, width, height);
      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i];
        p.life += 1;
        p.vy += 0.32; // gravity
        p.vx *= 0.992; // air drag
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        p.tilt += 0.12;

        if (p.y > height + 40) {
          particles.splice(i, 1);
          continue;
        }

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        if (p.round) {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.scale(1, Math.abs(Math.cos(p.tilt))); // flutter
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        }
        ctx.restore();
      }

      if (elapsed < duration || particles.length > 0) {
        requestAnimationFrame(frame);
      } else {
        canvas.remove();
        resolve();
      }
    };
    requestAnimationFrame(frame);
  });
}
